import React from 'react';
import { InvoiceTrendChart } from '../Charts/InvoiceTrendChart';

const InvoicesTrend = ({ data = [] }) => (
  <div className="white-wraper extra-mt">
    <h2 className="add-margin">Invoice Trend ({data?.[0]?.year ?? new Date().getFullYear()})</h2>

    <div className="chart-data">
      <ul>
        <li>
          <div className="chart-dot cd11"></div>
          <p>CC Paid</p>
        </li>
        <li>
          <div className="chart-dot cd12"></div>
          <p>CC Pending</p>
        </li>
        <li>
          <div className="chart-dot cd13"></div>
          <p>TC Paid </p>
        </li>
         <li>
          <div className="chart-dot cd14"></div>
          <p>TC Pending </p>
        </li>
      </ul>
    </div>

    <div className="chart-canvas">
      {data.length > 0 ? (
        <InvoiceTrendChart data={data} />
      ) : (
        <div className="text-center text-secondary" style={{ display:'flex', width:'100%', alignItems:'center', justifyContent:'center' }}>No data available</div>
      )}
    </div>
  </div>
);

export default InvoicesTrend;
